export default {
  title: 'Checkout',
  labels: {
    login: 'Login to use your saved info and loyalty points',
    continue_as_guest: 'or continue as guest',
  },
  buttons: {
    login: 'Log in to pay with points',
    demo_mode: 'Demo mode',
  },
};
